import React from "react";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { Clickable } from "../Clickables";
import { Svg } from "../Svg";

import styles from "./index.module.scss";

export function SKSArrows({
    allVisible,
    className,
}: {
    allVisible: boolean;
    className?: string;
}) {
    if (allVisible) return null;
    return (
        <div className={concatClassNames([styles.controls, className])}>
            <Clickable slot="previous" className={styles.arrowPrev}>
                <Svg name="caret-right" className={styles.arrowSvg} />
            </Clickable>
            <Clickable slot="next" className={styles.arrowNext}>
                <Svg name="caret-right" className={styles.arrowSvg} />
            </Clickable>
        </div>
    );
}
